import { queryOptions, useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { isNotFoundError } from '../errors';
import { basePath } from '../mutations/useProcessDraft/shared';
import { processDraftKeys } from '../query-keys';
import type { GetProcessDraftResponse } from '@bliks-io/contracts';

export type ProcessDraftQueryStatus = GetProcessDraftResponse | 'not-found';

export const processDraftQueryOptions = (processId: string) =>
  queryOptions({
    queryKey: processDraftKeys.detail(processId),
    queryFn: async ({ signal }): Promise<ProcessDraftQueryStatus> => {
      try {
        const { data } = await apiClient.get<GetProcessDraftResponse>(basePath(processId), {
          signal
        });
        return data;
      } catch (error) {
        if (isNotFoundError(error)) return 'not-found';
        throw error;
      }
    },
    retry: false,
    staleTime: 5_000
  });

export function useProcessDraft(processId: string, enabled = true) {
  return useQuery({
    ...processDraftQueryOptions(processId),
    enabled
  });
}
